export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_17.98c9e438.jpg";